(function () {
  'use strict';

  const SUBSCRIBE_ATTR = 'data-atc-text-subscribe';
  const ONETIME_ATTR = 'data-atc-text-onetime';
  const NOTICE_CLASS = 'subscription-commitment-notice';
  const NOTICE_TEXT = 'Your subscription includes a minimum of 2 deliveries';
  const NOTICE_TOOLTIP_TEXT = 'Subscriptions require a minimum of 2 deliveries before you can cancel. After your second shipment, you may cancel at any time without incurring cancellation fees.';
  const NOTICE_TOOLTIP_CLASS = 'subscription-commitment-notice__tooltip';
  const NOTICE_STYLE_ID = 'subscription-commitment-notice-styles';
  const NOTICE_STYLES = [
    '.' + NOTICE_CLASS + '{',
    '  position: relative;',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 0.75rem;',
    '  margin: 0.75rem 0 0.25rem;',
    '  padding: 0.875rem 1rem;',
    '  background-color: #fff6e6;',
    '  color: #7a5a1f;',
    '  border: 1px solid #f1e0b8;',
    '  border-left: 3px solid #c9971f;',
    '  border-radius: 0.5rem;',
    '  font-size: 2rem;',
    '  line-height: 1.4;',
    '  cursor: help;',
    '}',
    '.' + NOTICE_CLASS + ':focus{',
    '  outline: 2px solid #c9971f;',
    '  outline-offset: 2px;',
    '}',
    '.' + NOTICE_CLASS + ' svg{',
    '  flex: 0 0 auto;',
    '  width: 2rem;',
    '  height: 2rem;',
    '  color: #c9971f;',
    '}',
    '.' + NOTICE_CLASS + ' p{',
    '  margin: 0;',
    '  font-weight: 500;',
    '}',
    '.' + NOTICE_TOOLTIP_CLASS + '{',
    '  position: absolute;',
    '  bottom: calc(100% + 0.5rem);',
    '  left: 0;',
    '  right: 0;',
    '  max-width: 32rem;',
    '  padding: 0.75rem 1rem;',
    '  background-color: #7a5a1f;',
    '  color: #fff6e6;',
    '  border-radius: 0.5rem;',
    '  font-size: 1.6rem;',
    '  font-weight: 400;',
    '  line-height: 1.4;',
    '  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);',
    '  z-index: 5;',
    '  pointer-events: none;',
    '  opacity: 0;',
    '  visibility: hidden;',
    '  transform: translateY(4px);',
    '  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;',
    '}',
    '.' + NOTICE_TOOLTIP_CLASS + '::after{',
    '  content: "";',
    '  position: absolute;',
    '  top: 100%;',
    '  left: 1.25rem;',
    '  border: 6px solid transparent;',
    '  border-top-color: #7a5a1f;',
    '}',
    '.' + NOTICE_CLASS + ':hover .' + NOTICE_TOOLTIP_CLASS + ',',
    '.' + NOTICE_CLASS + ':focus .' + NOTICE_TOOLTIP_CLASS + ',',
    '.' + NOTICE_CLASS + ':focus-within .' + NOTICE_TOOLTIP_CLASS + '{',
    '  opacity: 1;',
    '  visibility: visible;',
    '  transform: translateY(0);',
    '}'
  ].join('\n');
  const NOTICE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';

  let tooltipIdCounter = 0;

  function ensureStyles() {
    if (document.getElementById(NOTICE_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = NOTICE_STYLE_ID;
    style.textContent = NOTICE_STYLES;
    document.head.appendChild(style);
  }

  function getSellingPlanValue(form) {
    const inputs = form.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]');
    for (const el of inputs) {
      if (el.disabled) continue;
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked && el.value) return el.value;
        continue;
      }
      if (el.value) return el.value;
    }
    return '';
  }

  function getProductForm(el) {
    return (el && el.closest('form')) || document.querySelector('form[action*="/cart/add"]');
  }

  function syncButton(button) {
    const form = button.form || button.closest('form');
    if (!form) return;

    const subscribeText = button.getAttribute(SUBSCRIBE_ATTR);
    const onetimeText = button.getAttribute(ONETIME_ATTR);
    if (!subscribeText || !onetimeText) return;

    const sellingPlan = getSellingPlanValue(form);
    const nextText = sellingPlan ? subscribeText : onetimeText;

    if (button.dataset.addToCartText !== nextText) {
      button.dataset.addToCartText = nextText;
    }

    if (!button.disabled && button.textContent.trim() !== nextText) {
      button.textContent = nextText;
    }
  }

  function initForButton(button) {
    if (button.dataset.rechargeAtcSyncBound === 'true') return;
    const form = button.form || button.closest('form');
    if (!form) return;

    button.dataset.rechargeAtcSyncBound = 'true';

    const handler = () => syncButton(button);

    form.addEventListener('change', handler, true);
    form.addEventListener('input', handler, true);

    const observer = new MutationObserver(handler);
    observer.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'disabled', 'name']
    });

    syncButton(button);
  }

  function setNoticeVisible(notice, visible) {
    notice.style.display = visible ? '' : 'none';
  }

  function ensureNoticeElement(widget) {
    const next = widget.nextElementSibling;
    if (next && next.classList && next.classList.contains(NOTICE_CLASS)) {
      return next;
    }
    ensureStyles();
    const notice = document.createElement('div');
    const tooltipId = NOTICE_CLASS + '-tooltip-' + (++tooltipIdCounter);
    notice.className = NOTICE_CLASS;
    notice.setAttribute('role', 'note');
    notice.setAttribute('tabindex', '0');
    notice.setAttribute('aria-describedby', tooltipId);
    notice.innerHTML =
      NOTICE_ICON_SVG +
      '<p>' + NOTICE_TEXT + '</p>' +
      '<span class="' + NOTICE_TOOLTIP_CLASS + '" role="tooltip" id="' + tooltipId + '">' +
      NOTICE_TOOLTIP_TEXT +
      '</span>';
    setNoticeVisible(notice, false);
    widget.insertAdjacentElement('afterend', notice);
    return notice;
  }

  function isSubscriptionSelectedInWidget(widget) {
    const subRadio = widget.querySelector('input[name="purchaseOption"][value="subscription"]');
    if (subRadio) return subRadio.checked;
    const anyChecked = widget.querySelector('input[name="purchaseOption"]:checked');
    if (anyChecked && anyChecked.value && anyChecked.value !== 'onetime') return true;
    return false;
  }

  function syncNotice(widget) {
    if (!widget.isConnected) return;
    const notice = ensureNoticeElement(widget);

    let shouldBeVisible = isSubscriptionSelectedInWidget(widget);

    if (!shouldBeVisible) {
      const form = getProductForm(widget);
      if (form && getSellingPlanValue(form)) {
        shouldBeVisible = true;
      }
    }

    setNoticeVisible(notice, shouldBeVisible);
  }

  function initNoticeForWidget(widget) {
    if (widget.dataset.commitmentNoticeBound === 'true') return;

    widget.dataset.commitmentNoticeBound = 'true';
    const form = getProductForm(widget);

    const handler = () => syncNotice(widget);

    widget.addEventListener('change', handler, true);
    widget.addEventListener('input', handler, true);
    widget.addEventListener('click', handler, true);

    const widgetObserver = new MutationObserver(handler);
    widgetObserver.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'disabled', 'name', 'class']
    });

    if (form) {
      form.addEventListener('change', handler, true);
      form.addEventListener('input', handler, true);

      const formObserver = new MutationObserver(handler);
      formObserver.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'disabled', 'name']
      });
    }

    syncNotice(widget);
  }

  function cleanupOrphanedNotices() {
    document.querySelectorAll('.' + NOTICE_CLASS).forEach((notice) => {
      if (notice.hasAttribute('data-static-notice')) return;
      const prev = notice.previousElementSibling;
      if (!prev || !prev.classList || !prev.classList.contains('rc-widget')) {
        notice.remove();
      }
    });
  }

  function init() {
    ensureStyles();
    const initialButtons = document.querySelectorAll('button[' + SUBSCRIBE_ATTR + ']');
    const initialWidgets = document.querySelectorAll('.rc-widget');

    initialButtons.forEach(initForButton);
    initialWidgets.forEach(initNoticeForWidget);

    const pageObserver = new MutationObserver(() => {
      document.querySelectorAll('button[' + SUBSCRIBE_ATTR + ']').forEach((btn) => {
        initForButton(btn);
        syncButton(btn);
      });
      document.querySelectorAll('.rc-widget').forEach((widget) => {
        initNoticeForWidget(widget);
        syncNotice(widget);
      });
      cleanupOrphanedNotices();
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
